var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMachine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 99,
    viewBox: "0 0 99 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.4102 32.05L67.3302 32.02L64.9502 36.62L66.4602 44.75L70.6302 46.25V37.34L72.8302 34.67",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8507 32.0801L92.2007 36.6201L90.6807 44.7501L86.5207 46.2501V37.3401L84.2207 34.5601",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3502 33.8899H73.9102",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7796 16.51L67.0996 7.53003",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4697 11.73H63.4797L72.9597 20.53",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4997 3.94995L36.2197 3.96997",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4799 9.5L36.22 9.52002H36.21",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2197 11.76L22.5497 30.29L22.4697 30.45",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9201 8.6499L16.4102 26.8899",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7598 27.7499V22.03C72.7598 21.5 72.8198 21 72.9598 20.52C73.4698 18.62 74.9098 17.0999 76.7798 16.4999C77.3398 16.3199 77.9498 16.21 78.5798 16.21C81.7898 16.21 84.3898 18.82 84.3898 22.03V27.8",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9001 28.1001H73.3701",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.43 72.4399H1V97.4999H30.43V72.4399Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2897 65.1199H4.13965V72.4399H27.2897V65.1199Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2897 65.1199H4.13965V72.4399H27.2897V65.1199Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.05972 39.72H8.46973V65.1199H22.9497V39.72H22.3597",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3604 30.29H22.5504H28.6504V39.72H22.9503H22.3604",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M9.06027 30.29H2.78027V39.72H8.47028H9.06027",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3002 79.8699H6.9502",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3002 84.97H6.9502",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3002 90.0698H6.9502",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4699 79.8699H17.1299",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4699 84.97H17.1299",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4699 90.0698H17.1299",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M19.39 48.8601H12.04",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M19.39 53.96H12.04",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M19.39 59.0601H12.04",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7096 43.1601C20.2107 43.1601 23.8596 39.5112 23.8596 35.0101C23.8596 30.509 20.2107 26.8601 15.7096 26.8601C11.2084 26.8601 7.55957 30.509 7.55957 35.0101C7.55957 39.5112 11.2084 43.1601 15.7096 43.1601Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7104 38.53C17.6545 38.53 19.2304 36.954 19.2304 35.0099C19.2304 33.0659 17.6545 31.49 15.7104 31.49C13.7664 31.49 12.1904 33.0659 12.1904 35.0099C12.1904 36.954 13.7664 38.53 15.7104 38.53Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M31.78 11.98C34.674 11.98 37.02 9.63399 37.02 6.74002C37.02 3.84605 34.674 1.5 31.78 1.5C28.8861 1.5 26.54 3.84605 26.54 6.74002C26.54 9.63399 28.8861 11.98 31.78 11.98Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9197 11.98C64.8137 11.98 67.1597 9.63399 67.1597 6.74002C67.1597 3.84605 64.8137 1.5 61.9197 1.5C59.0257 1.5 56.6797 3.84605 56.6797 6.74002C56.6797 9.63399 59.0257 11.98 61.9197 11.98Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5699 25.0201C80.2157 25.0201 81.5498 23.6859 81.5498 22.0401C81.5498 20.3943 80.2157 19.0601 78.5699 19.0601C76.924 19.0601 75.5898 20.3943 75.5898 22.0401C75.5898 23.6859 76.924 25.0201 78.5699 25.0201Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1603 35.0699C73.2811 35.0699 75.0003 33.3507 75.0003 31.2299C75.0003 29.1091 73.2811 27.3899 71.1603 27.3899C69.0395 27.3899 67.3203 29.1091 67.3203 31.2299C67.3203 33.3507 69.0395 35.0699 71.1603 35.0699Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1095 35.0699C88.2303 35.0699 89.9495 33.3507 89.9495 31.2299C89.9495 29.1091 88.2303 27.3899 86.1095 27.3899C83.9888 27.3899 82.2695 29.1091 82.2695 31.2299C82.2695 33.3507 83.9888 35.0699 86.1095 35.0699Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8598 73.4299L70.0798 69.1399L65.1198 70.0199L61.7398 66.6399L62.6198 61.6799L58.3298 59.8999L55.4498 64.0299H50.6698L47.7898 59.8999L43.4998 61.6799L44.3798 66.6399L40.9998 70.0199L36.0398 69.1399L34.2598 73.4299L38.3898 76.3099V81.0899L34.2598 83.9699L36.0398 88.2599L40.9998 87.3799L44.3798 90.7599L43.4998 95.7199L47.7898 97.4999L50.6698 93.3699H55.4498L58.3298 97.4999L62.6198 95.7199L61.7398 90.7599L65.1198 87.3799L70.0798 88.2599L71.8598 83.9699L67.7298 81.0899V76.3099L71.8598 73.4299ZM48.5498 82.9199C47.8998 84.4899 46.0998 85.2299 44.5298 84.5799C42.9598 83.9299 42.2198 82.1299 42.8698 80.5599C43.5198 78.9899 45.3198 78.2499 46.8898 78.8999C48.4598 79.5499 49.1998 81.3499 48.5498 82.9199ZM47.1798 70.1799C47.8298 68.6099 49.6298 67.8699 51.1998 68.5199C52.7698 69.1699 53.5098 70.9699 52.8598 72.5399C52.2098 74.1099 50.4098 74.8499 48.8398 74.1999C47.2698 73.5499 46.5298 71.7499 47.1798 70.1799ZM53.8098 79.0099C53.6398 79.4199 53.1698 79.6199 52.7498 79.4499C52.3398 79.2799 52.1398 78.8099 52.3098 78.3899C52.4798 77.9699 52.9498 77.7799 53.3698 77.9499C53.7798 78.1199 53.9798 78.5899 53.8098 79.0099ZM58.9498 87.2299C58.2998 88.7999 56.4998 89.5399 54.9298 88.8899C53.3598 88.2399 52.6198 86.4399 53.2698 84.8699C53.9198 83.2999 55.7198 82.5599 57.2898 83.2099C58.8598 83.8599 59.5998 85.6599 58.9498 87.2299ZM63.2498 76.8299C62.5998 78.3999 60.7998 79.1399 59.2298 78.4899C57.6598 77.8399 56.9198 76.0399 57.5698 74.4699C58.2198 72.8999 60.0198 72.1599 61.5898 72.8099C63.1598 73.4599 63.8998 75.2599 63.2498 76.8299Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0097 87.0699L96.9997 89.55L94.8997 93.1899L91.2497 91.84L88.0897 93.66L87.4397 97.4999H83.2397L82.5897 93.66L79.4297 91.84L75.7797 93.1899L73.6797 89.55L76.6697 87.0699V83.42L73.6797 80.9399L75.7797 77.3L79.4297 78.65L82.5897 76.83L83.2397 72.99H87.4397L88.0897 76.83L91.2497 78.65L94.8997 77.3L96.9997 80.9399L94.0097 83.42V87.0699ZM81.9597 87.1899C83.0397 89.0499 85.4197 89.6899 87.2797 88.6199C89.1397 87.5399 89.7797 85.16 88.7097 83.3C87.6297 81.44 85.2497 80.7999 83.3897 81.8699C81.5297 82.9399 80.8897 85.3299 81.9597 87.1899Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2 47.56L72.55 45.13L75.31 43.54L77.09 45.32H80.06L81.84 43.54L84.6 45.13L83.95 47.56L85.43 50.13L87.86 50.78V53.96L85.43 54.61L83.95 57.18L84.6 59.61L81.84 61.2L80.06 59.42H77.09L75.31 61.2L72.55 59.61L73.2 57.18L71.72 54.61L69.29 53.96V50.78L71.72 50.13L73.2 47.56ZM80.44 52.38C80.44 51.35 79.6 50.51 78.57 50.51C77.54 50.51 76.7 51.35 76.7 52.38C76.7 53.41 77.54 54.25 78.57 54.25C79.6 54.25 80.44 53.41 80.44 52.38Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMachine);
export default __webpack_public_path__ + "static/media/machine.c02ba869c2e989dbc5fd0c967918622e.svg";
export { ForwardRef as ReactComponent };